import { render } from "./GerarNovoPedido.vue?vue&type=template&id=c51cdcd0&scoped=true"
import script from "./GerarNovoPedido.vue?vue&type=script&lang=js"
export * from "./GerarNovoPedido.vue?vue&type=script&lang=js"

import "./GerarNovoPedido.vue?vue&type=style&index=0&id=c51cdcd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51cdcd0"]])

export default __exports__